import React from 'react'
import classNames from 'classnames'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import Badge from '@toasttab/shared/src/components/atoms/Badge/Badge'
import { BasicListOptions } from '@toasttab/shared/src/utils/Contentful/richText'
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as IconAddCircle } from '@toasttab/shared/src/assets/svg/circle-ui-actions/icon-add-circle.svg'
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as IconSubtractCircle } from '@toasttab/shared/src/assets/svg/circle-ui-actions/icon-subtract-circle.svg'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { microcopyTransform } from '@toasttab/shared/src/utils/contentfulUtils'
import { AccordionItemProps } from '../Accordion.d'

const AccordionItem = ({
  sectionHeading,
  ctaLabel,
  wysiwygV2,
  badgeColor = 'bg-yellow-25',
  bgColor = 'bg-gray-0',
  isActive = false,
  shadow = false,
  onClick,
  itemNumber = 1
}: AccordionItemProps) => {
  const { microCopyData } = usePageContext()
  const id = sectionHeading.replace(/\s+/g, '-').toLowerCase()

  const buttonClass = classNames(
    'items-center rounded-xl border-none flex font-semibold justify-start py-4 px-6 text-left w-full leading-[24px] block',
    {
      'shadow-xl': shadow,
      [bgColor]: !isActive,
      'bg-gray-125': isActive
    }
  )

  const tabTitleClass = classNames({
    'mr-6 md:mr-0 leading-[24px] block': true,
    'text-default': !isActive,
    'text-white': isActive
  })

  const panelClass = classNames(
    'mb-8 text-secondary pt-6 px-8 [&>p:not(:last-child)]:mb-3',
    {
      hidden: !isActive,
      block: isActive
    }
  )

  const renderIcons = () => {
    if (isActive) {
      return (
        <IconSubtractCircle
          width='24'
          height='24'
          viewBox='0 0 24 24'
          stroke='#ffffff'
          className='ml-auto flex-shrink-0'
        />
      )
    } else {
      return (
        <IconAddCircle
          width='24'
          height='24'
          viewBox='2 2 24 24'
          fill='#252525'
          className='ml-auto flex-shrink-0'
        />
      )
    }
  }

  const hasRichText = !!wysiwygV2?.raw
  if (hasRichText) {
    wysiwygV2.raw = microcopyTransform(microCopyData, wysiwygV2.raw)
  }

  return (
    <div
      className='mb-6 accordion-item tracking-[0.2px]'
      data-testid={`accordion-item-${itemNumber}`}
    >
      <button
        className={buttonClass}
        aria-controls={id}
        onClick={onClick}
        id={id}
      >
        <span className={tabTitleClass}>{sectionHeading}</span>
        {ctaLabel && (
          <Badge
            badgeColor={badgeColor}
            text={ctaLabel}
            uppercase={true}
            classes='ml-2'
          />
        )}
        {renderIcons()}
      </button>
      <div
        aria-labelledby={id}
        className={panelClass}
        data-testid={`accordion-panel-${itemNumber}`}
        role='tabpanel'
      >
        {hasRichText ? (
          renderRichText(wysiwygV2, BasicListOptions)
        ) : (
          <span
            dangerouslySetInnerHTML={{
              __html: microcopyTransform(microCopyData, wysiwygV2)
            }}
          />
        )}
      </div>
    </div>
  )
}

export default AccordionItem
